export function rgaStates() {
  return [
    { name: 'Georgia', abbreviation: 'GA' },
    { name: 'Hawaii', abbreviation: 'HI' },
    { name: 'Illinois', abbreviation: 'IL' },
    { name: 'Iowa', abbreviation: 'IA' },
    { name: 'Kansas', abbreviation: 'KS' },
    { name: 'Maine', abbreviation: 'ME' },
    { name: 'New Hampshire', abbreviation: 'NH' },
    { name: 'New Jersey', abbreviation: 'NJ' },
    { name: 'North Dakota', abbreviation: 'ND' },
    { name: 'Ohio', abbreviation: 'OH' },
    { name: 'Rhode Island', abbreviation: 'RI' },
    { name: 'South Carolina', abbreviation: 'SC' },
    { name: 'Wyoming', abbreviation: 'WY' },
  ]
}

export function getRGAStateByAbbreviation(abbreviation: string) {
  return rgaStates().find((state) => state.abbreviation === abbreviation)
}

export function getRGAStateByName(name: string) {
  return rgaStates().find((state) => state.name === name)
}

export function getRGAStateByAbbreviationOrName(value: string) {
  return getRGAStateByAbbreviation(value) || getRGAStateByName(value)
}
